module.exports = __webpack_public_path__ + "assets/img/14a.e26b27c5.jpg";